import * as $ from "jquery";
import { $body } from "../../Core/Body";
import DeliveryFields from "../Fields/DeliveryFields";
import InvoiceFields from "../Fields/InvoiceFields";
import CartFields from "../Fields/CartFields";
import CartOfferFields from "../Fields/CartOfferFields";
import {calculateWindowOffset} from "../../Functions/CalculateWindowOffset";

export default class Step2FormValidation
{
    readonly Selector: any;

    constructor()
    {
        this.validate = this.validate.bind(this);
        this.Selector = {
            FORM       : '#step2_form',
            INPUT_DELIVERY_RADIO   : $('.delivery_method_radio:checked'),
            INPUT_DELIVERY_ID   : $('#cart_delivery_department_id'),
            DEPARTMENT_CONTAINER_ID : $('#personal-department-contener'),
            WANT_INVOICE     : $('#want_invoice'),
            IS_LOGGED_IN     : false,
            PAYU_CHECKED     : $('#payment_method_1').find('input'),
            SUBMIT_BUTTON    : $('#lastStepButton')
        }
    }

    public validate()
    {
        let rules = Object.assign({},
            CartFields.getFields(this.Selector),
            CartOfferFields.getFields(this.Selector),
            DeliveryFields.getFields(this.Selector),
            InvoiceFields.getFields(this.Selector),
        )

        let inputDeliveryId = this.Selector.INPUT_DELIVERY_ID;
        let divDepartmentContainer = this.Selector.DEPARTMENT_CONTAINER_ID;

        $(this.Selector.FORM).validate({
            rules: rules,
            ignore: ':hidden:not([data-validation="true"])',
            errorElement: 'div',
            errorClass:   'invalid-feedback',
            highlight: function(element, errorClass){
                if($(element)[0] == inputDeliveryId[0]){
                    divDepartmentContainer.addClass('is-invalid').removeClass(errorClass);
                }else{
                    $(element).addClass('is-invalid').removeClass(errorClass);
                }
            },
            unhighlight: function(element, errorClass){
                if($(element)[0] == inputDeliveryId[0]){
                    divDepartmentContainer.removeClass('is-invalid').removeClass(errorClass);
                }else{
                    $(element).removeClass('is-invalid').removeClass(errorClass);
                }
            },
            invalidHandler: function (form, validator) {
                if (!validator.numberOfInvalids())
                    return;

                let offsetElement;
                if ($(validator.errorList[0].element)[0] == inputDeliveryId[0]) {
                    offsetElement = divDepartmentContainer;
                } else {
                    offsetElement = $(validator.errorList[0].element);
                }

                $('html, body').animate({
                    scrollTop: offsetElement.offset().top - calculateWindowOffset()
                }, 600);
            }
        });

        return $(this.Selector.FORM).valid();
    }

}
import * as $ from "jquery";
import { $body } from "../../Core/Body";
import DeliveryFields from "../Fields/DeliveryFields";
import InvoiceFields from "../Fields/InvoiceFields";
import CartFields from "../Fields/CartFields";
import CartOfferFields from "../Fields/CartOfferFields";
import {calculateWindowOffset} from "../../Functions/CalculateWindowOffset";

export default class Step2FormValidation
{
    readonly Selector: any;

    constructor()
    {
        this.validate = this.validate.bind(this);
        this.Selector = {
            FORM       : '#step2_form',
            INPUT_DELIVERY_RADIO   : $('.delivery_method_radio:checked'),
            INPUT_DELIVERY_ID   : $('#cart_delivery_department_id'),
            DEPARTMENT_CONTAINER_ID : $('#personal-department-contener'),
            WANT_INVOICE     : $('#want_invoice'),
            IS_LOGGED_IN     : false,
            PAYU_CHECKED     : $('#payment_method_1').find('input'),
            SUBMIT_BUTTON    : $('#lastStepButton')
        }
    }

    public validate()
    {
        let rules = Object.assign({},
            CartFields.getFields(this.Selector),
            CartOfferFields.getFields(this.Selector),
            DeliveryFields.getFields(this.Selector),
            InvoiceFields.getFields(this.Selector),
        )

        let inputDeliveryId = this.Selector.INPUT_DELIVERY_ID;
        let divDepartmentContainer = this.Selector.DEPARTMENT_CONTAINER_ID;

        $(this.Selector.FORM).validate({
            rules: rules,
            ignore: ':hidden:not([data-validation="true"])',
            errorElement: 'div',
            errorClass:   'invalid-feedback',
            highlight: function(element, errorClass){
                if($(element)[0] == inputDeliveryId[0]){
                    divDepartmentContainer.addClass('is-invalid').removeClass(errorClass);
                }else{
                    $(element).addClass('is-invalid').removeClass(errorClass);
                }
            },
            unhighlight: function(element, errorClass){
                if($(element)[0] == inputDeliveryId[0]){
                    divDepartmentContainer.removeClass('is-invalid').removeClass(errorClass);
                }else{
                    $(element).removeClass('is-invalid').removeClass(errorClass);
                }
            },
            invalidHandler: function (form, validator) {
                if (!validator.numberOfInvalids())
                    return;

                let offsetElement;
                if ($(validator.errorList[0].element)[0] == inputDeliveryId[0]) {
                    offsetElement = divDepartmentContainer;
                } else {
                    offsetElement = $(validator.errorList[0].element);
                }

                $('html, body').animate({
                    scrollTop: offsetElement.offset().top - calculateWindowOffset()
                }, 600);
            }
        });

        return $(this.Selector.FORM).valid();
    }

}
